import React, { useEffect } from 'react';

const COLORS = {
  primary: "#0760ad",
  secondary: "#118a94",
  white: "#FFFFFF"
};

const DoctorsFilter = ({ 
  filters, 
  setFilters, 
  searchTerm, 
  setSearchTerm, 
  filterOptions = {
    genders: ['Male', 'Female'],
    specialties: [],
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  }
}) => {
  const genders = filterOptions?.genders || ['Male', 'Female'];
  const specialties = filterOptions?.specialties || [];
  const days = filterOptions?.days || ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  const handleSpecialtyChange = (specialtyId) => {
    setFilters(prev => ({
      ...prev,
      specialty: prev.specialty.includes(specialtyId)
        ? prev.specialty.filter(id => id !== specialtyId)
        : [...prev.specialty, specialtyId]
    }));
  };

  const handleDayChange = (day) => {
    setFilters(prev => ({
      ...prev,
      days: prev.days.includes(day)
        ? prev.days.filter(d => d !== day)
        : [...prev.days, day]
    }));
  };

  const handleGenderChange = (gender) => {
    setFilters(prev => ({
      ...prev,
      gender: gender === 'All' ? '' : gender
    }));
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClearFilters = () => {
    setFilters({
      gender: '',
      specialty: [],
      days: []
    });
    setSearchTerm('');
  };

  // Remove the Apply Filters button since we're doing real-time filtering
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm sticky top-4">
      <h3 className="text-xl font-bold mb-6" style={{ color: COLORS.primary }}>Search Filter</h3>
      
      {/* Search Input */}
      <div className="mb-6">
        <input
          type="text"
          placeholder="Search by name or specialty..."
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0760ad] focus:border-[#0760ad] transition"
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>

      {/* Gender Filter */}
      <div className="mb-6">
        <h5 className="font-medium mb-3">Gender</h5>
        <div className="space-y-2">
          {['All', ...genders].map(gender => (
            <div key={gender} className="flex items-center">
              <input
                id={`gender-${gender}`}
                type="radio"
                className="h-4 w-4 border-gray-300 focus:ring-[#0760ad]"
                checked={filters.gender === gender || (gender === 'All' && !filters.gender)}
                onChange={() => handleGenderChange(gender)}
              />
              <label htmlFor={`gender-${gender}`} className="ml-2 text-gray-700">
                {gender === 'All' ? 'All Doctors' : `${gender} Doctors`}
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Specialty Filter */}
      <div className="mb-6">
        <h5 className="font-medium mb-3">Specialty</h5>
        {specialties.length > 0 ? (
          <div className="space-y-2 max-h-60 overflow-y-auto">
            {specialties.map(specialty => (
              <div key={specialty.id} className="flex items-center">
                <input
                  id={`specialty-${specialty.id}`}
                  type="checkbox"
                  className="h-4 w-4 border-gray-300 rounded focus:ring-[#0760ad]"
                  checked={filters.specialty.includes(specialty.id)}
                  onChange={() => handleSpecialtyChange(specialty.id)}
                />
                <label htmlFor={`specialty-${specialty.id}`} className="ml-2 text-gray-700">
                  {specialty.name}
                </label>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-sm">Loading specialties...</p>
        )}
      </div>

      {/* Availability Filter */}
      <div className="mb-6">
        <h5 className="font-medium mb-3">Available Days</h5>
        <div className="grid grid-cols-2 gap-2">
          {days.map(day => (
            <div key={day} className="flex items-center">
              <input
                id={`day-${day}`}
                type="checkbox"
                className="h-4 w-4 border-gray-300 rounded focus:ring-[#0760ad]"
                checked={filters.days.includes(day)}
                onChange={() => handleDayChange(day)}
              />
              <label htmlFor={`day-${day}`} className="ml-2 text-gray-700">
                {day}
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Only keep Clear All button */}
      <button 
        onClick={handleClearFilters}
        className="w-full py-2 text-sm font-medium text-[#0760ad] border border-[#0760ad] rounded-md hover:bg-[#0760ad] hover:text-white transition"
      >
        Clear All Filters
      </button>
    </div>
  );
};

export default DoctorsFilter;